/*
 * @Description: 
 * @Author: Lim
 * @Date: 2020-08-28 17:45:04
 * @LastEditors: Lim
 * @LastEditTime: 2020-12-07 14:29:19
 */
import ajax from './ajax'

/**
 * 后台请求
 * 访客端请求
 */
let BASE_URL,BASE_VISITOR;
if ( process.env.NODE_ENV === 'production' ) {
    BASE_URL = window.location.origin+window.location.pathname;
    BASE_VISITOR = window.location.origin+window.location.pathname;
} else {
    BASE_URL = window.location.origin+'/test/p10000102_10000208';
    BASE_VISITOR = window.location.origin+'/visitor/10000102/e7227d2edcb0ace1baa3586fbd75753d';
}

// 请求侧边栏数据
export const getTabData = ( path, params, type ) => ajax( BASE_URL+ path, params, type );

// 表单操作
export const formListHandler = ( path, params, type ) => ajax( BASE_URL+ path, params, type );

// 表单访客端
export const getFormInfo = ( path, params, type ) => ajax( BASE_VISITOR+ path, params, type );
